import "./loading.css";

import { Box } from "@mui/material";
import React from "react";

import { LoadingLogo } from "shared/common/utils/icons/icons";

export default function Loading() {
  return (
    <Box
      sx={{
        position: "absolute",
        width: "100%",
        height: "100%",
        top: "0",
        zIndex: "100",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "blackBackground.main",
      }}
    >
      <LoadingLogo />
    </Box>
  );
}
